import InViewport from '../in-viewport';

export default {
  inserted(el, binding) {
    InViewport(el, binding.value);
  }
}
